export const TO_PUBLISH = "0";
export const PENDING = "10";
export const PROCESSING = "1";
export const PUBLISHED = "2";
export const PUBLISH_ERROR = "3";
export const ACCOUNT_NOT_ACTIVE = "4";
export const ACCOUNT_SUSPENDED = "5";
export const ACCOUNT_BLOCKED = "6";

export const SUCCESS_STATUSES = [PUBLISHED];
export const SCHEDULED_STATUSES = [TO_PUBLISH];
export const PROCESSING_STATUSES = [PROCESSING, PENDING];
export const ERROR_STATUSES = [
  PUBLISH_ERROR,
  ACCOUNT_NOT_ACTIVE,
  ACCOUNT_SUSPENDED,
  ACCOUNT_BLOCKED,
];
